// Supported time signatures and their beat counts
export const TIME_SIGNATURES = {
  '3/4': { beats: 3, base: 4 },
  '4/4': { beats: 4, base: 4 },
  '6/8': { beats: 6, base: 8 }
};
